import { render, staticRenderFns } from "./Magiun2.vue?vue&type=template&id=ea71efa0&scoped=true&"
import script from "./Magiun2.vue?vue&type=script&lang=js&"
export * from "./Magiun2.vue?vue&type=script&lang=js&"
import style0 from "./Magiun2.vue?vue&type=style&index=0&id=ea71efa0&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ea71efa0",
  null
  
)

export default component.exports